import { createClient } from "graphql-ws";
import { resolveGraphqlWsUrl } from "./resolveGraphqlWsUrl";

export const createGraphqlWsClient = ({ wsEnvUrl, httpEnvUrl }) => {
  const url = resolveGraphqlWsUrl(wsEnvUrl, httpEnvUrl);
  if (!url) {
    return null;
  }
  return createClient({
    url,
    connectionParams: () => ({}),
    retryAttempts: Infinity,
    shouldRetry: () => true,
    keepAlive: 15_000,
  });
};
